export function webhookActions(self) {
    return [
    {value: "CREATE", text: self.$t('webhook.action.CREATE') },
    {value: "UPDATE", text: self.$t('webhook.action.UPDATE') },
    {value: "DELETE", text: self.$t('webhook.action.DELETE') }
  ]
}
